<template>
  <div class="fp">
    <div class="fp-head">
      <div class="fp-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="#1976D2" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="15" r="4"/><path d="M10.85 12.15 19 4M18 5l2 2M15 8l2 2"/></svg>
      </div>
      <h2 class="fp-title">Forgot password</h2>
      <p class="fp-subtitle">Enter your email and we'll send you a new password.</p>
    </div>

    <form class="fp-form" @submit.prevent="sendMail">
      <div class="fp-field">
        <label class="fp-label" for="input-1">Email</label>
        <div class="fp-input">
          <svg class="fp-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>
          <input id="input-1" v-model="form.username" type="email" required autocomplete="username" autocapitalize="none" autocorrect="off" spellcheck="false" placeholder="you@company.com" />
        </div>
      </div>

      <transition name="fp-fade">
        <div v-if="alert.show && alert.variant === 'success'" class="fp-note fp-ok" id="login-alert">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
          <span>{{ alert.message }}</span>
        </div>
      </transition>
      <transition name="fp-fade">
        <div v-if="alert.show && alert.variant === 'danger'" class="fp-note fp-err" id="login-alert">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></svg>
          <span>{{ alert.message }}</span>
        </div>
      </transition>

      <button class="fp-submit" type="submit" :disabled="sending">
        <span v-if="sending" class="fp-spinner" aria-hidden="true"></span>
        <span>{{ sending ? 'Sending&hellip;' : 'Send new password' }}</span>
      </button>
    </form>

    <div class="fp-back">
      <b-link class="fp-link" @click="auth_navigation">Return to log in</b-link>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'ForgotPassword',
        data() {
            return {
                form: {},
                sending: false,
                alert: { show: false, message: '', variant: '' },
            }
        },
        methods: {
            async sendMail() {
                this.sending = true
                this.alert = { show: false, message: '', variant: '' }
                try {
                    await axios.put(
                        process.env.VUE_APP_API_URL + "bookings/reset-password",
                        this.form,
                        { headers: { 'Access-Control-Allow-Origin': '*' } }
                    )
                    this.alert = { show: true, message: "An email with a new password has been sent", variant: 'success' }
                    this.sending = false
                    setTimeout(() => {
                        this.$emit('auth_navigation', false)
                    }, 5000)
                } catch (e) {
                    const msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : "Unable to send email"
                    this.alert = { show: true, message: msg, variant: 'danger' }
                    this.sending = false
                }
            },
            auth_navigation() {
                this.$emit('auth_navigation', false)
            }
        }
    }
</script>

<style scoped>
.fp { text-align: left; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #0a0d14; }
.fp-head { text-align: center; margin-bottom: 22px; }
.fp-icon { width: 52px; height: 52px; margin: 0 auto 14px; border-radius: 50%; background: rgba(25,118,210,0.10); display: grid; place-items: center; }
.fp-icon svg { width: 24px; height: 24px; }
.fp-title { margin: 0; font-size: 21px; font-weight: 700; letter-spacing: -0.01em; color: #1976D2; }
.fp-subtitle { margin: 6px 0 0; font-size: 14px; color: #5b6470; line-height: 1.45; }

.fp-form { display: flex; flex-direction: column; gap: 16px; }
.fp-field { display: flex; flex-direction: column; gap: 7px; }
.fp-label { font-size: 13px; font-weight: 600; color: #3a4250; text-align: left; }
.fp-input { display: flex; align-items: center; gap: 10px; height: 48px; padding: 0 14px; background: #f5f7fa; border: 1.5px solid #e3e8ef; border-radius: 11px; transition: border-color .15s ease, box-shadow .15s ease, background .15s ease; }
.fp-input:focus-within { background: #fff; border-color: #1976D2; box-shadow: 0 0 0 4px rgba(25,118,210,0.12); }
.fp-input .fp-ic { width: 18px; height: 18px; color: #98a2b3; flex: none; transition: color .15s ease; }
.fp-input:focus-within .fp-ic { color: #1976D2; }
/* 16px minimum: ios safari auto-zooms focused inputs below 16px */
.fp-input input { flex: 1 1 auto; min-width: 0; border: 0; outline: 0; background: transparent; font-size: 16px; color: #0a0d14; }
.fp-input input::placeholder { color: #a4abb8; }

.fp-note { display: flex; align-items: center; gap: 9px; padding: 10px 12px; border-radius: 10px; font-size: 13.5px; line-height: 1.35; }
.fp-note svg { width: 18px; height: 18px; flex: none; }
.fp-ok { background: #e9f7ef; color: #1c7a47; }
.fp-err { background: #fdecea; color: #b5372a; }

.fp-submit { height: 48px; margin-top: 2px; border: 0; border-radius: 11px; background: linear-gradient(180deg, #1f86e6 0%, #1565C0 100%); color: #fff; font-size: 15.5px; font-weight: 650; letter-spacing: 0.01em; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px; box-shadow: 0 8px 18px rgba(25,118,210,0.28); transition: filter .15s ease, transform .04s ease, box-shadow .15s ease; }
.fp-submit:hover:not(:disabled) { filter: brightness(1.05); }
.fp-submit:active:not(:disabled) { transform: translateY(1px); }
.fp-submit:disabled { opacity: 0.65; cursor: default; box-shadow: none; }
.fp-spinner { width: 17px; height: 17px; border: 2.5px solid rgba(255,255,255,0.45); border-top-color: #fff; border-radius: 50%; animation: fp-spin 0.7s linear infinite; }
@keyframes fp-spin { to { transform: rotate(360deg); } }

.fp-back { text-align: center; margin-top: 20px; }
.fp-link { color: #1976D2; font-size: 13.5px; font-weight: 600; text-decoration: none; cursor: pointer; }
.fp-link:hover { text-decoration: underline; color: #1565C0; }

.fp-fade-enter-active, .fp-fade-leave-active { transition: opacity .2s ease; }
.fp-fade-enter, .fp-fade-leave-to { opacity: 0; }
</style>
